import React, { useState } from "react";
import "../styles/components/Popup.scss";

function Popup({
  title = "",

  detail = [],
  buttonLeftText = "",
  buttonRightText = "",
  setOpenPopup,
  handleClick,
  haveButton = true,
  haveCloseButton = true,
}) {
  return (
    <div className="pop">
      <div className="pop-content">
        {" "}
        {haveCloseButton ? (
          <span
            className="pop-content-close"
            onClick={() => setOpenPopup(false)}
          >
            ✕
          </span>
        ) : (
          <></>
        )}
        <div className="pop-content-wrapper">
          <div
            className="pop-content-title"
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
        </div>
        <div className="pop-content-course">
          {detail.map((d, key) => {
            return (
              <div key={key}>
                <div className="pop-content-text">{d}</div>
                <br></br>
              </div>
            );
          })}
        </div>
        {haveButton ? (
          <div className="button-container">
            <div className="button-left" onClick={handleClick}>
              {buttonLeftText}
            </div>
            <div className="button-right" onClick={() => setOpenPopup(false)}>
              {buttonRightText}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default Popup;
